"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.publishProductResolver = exports.unpublishProductResolver = void 0;
const effect_1 = require("effect");
const HttpClientRequest = __importStar(require("@effect/platform/HttpClientRequest"));
const manifestAuthoring_1 = require("../manifestAuthoring");
const unpublishProductResolver = (http, manifestUrl) => effect_1.RequestResolver.fromEffect((request) => HttpClientRequest.patch(`${manifestUrl}/api/v1/${request.tenant}/products/${request.productId}/published-status`, {
    headers: {
        authorization: `Bearer ${request.token}`,
        'content-type': 'application/json',
    },
}).pipe(HttpClientRequest.bodyJson({
    [request.solution]: 'unpublished',
}), effect_1.Effect.flatMap(http.execute), effect_1.Effect.scoped, effect_1.Effect.mapError(e => new manifestAuthoring_1.WriteManifestError({ originalError: e }))));
exports.unpublishProductResolver = unpublishProductResolver;
const publishProductResolver = (http, manifestUrl) => effect_1.RequestResolver.fromEffect((request) => HttpClientRequest.patch(`${manifestUrl}/api/v1/${request.tenant}/products/${request.productId}/published-status`, {
    headers: {
        authorization: `Bearer ${request.token}`,
        'content-type': 'application/json',
    },
}).pipe(HttpClientRequest.bodyJson({
    [request.solution]: 'published',
}), effect_1.Effect.flatMap(http.execute), effect_1.Effect.scoped, effect_1.Effect.mapError(e => new manifestAuthoring_1.WriteManifestError({ originalError: e }))));
exports.publishProductResolver = publishProductResolver;
